var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{attrs:{"size":"md","outline":"","no-caps":"","color":_vm.color,"text-color":_vm.textcolor,"label":_vm.label,"icon":("fa fa-" + _vm.icon)}})}
var staticRenderFns = []

export { render, staticRenderFns }